module.exports = __webpack_public_path__ + "static/media/Sec-1_2677HomePlayer_EN_VN_Mobile.d1c61890.png";